if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.getElementById('click-effect').remove();
else {
    const SIZE = 16;
    const SIZE_ACTIVE = 18;
    const BORDER = 8;
    const BORDER_ACTIVE = 9;
    const effect = document.getElementById('click-effect');
    document.addEventListener('pointerdown', (event)=>{
        const controller = new AbortController();
        const { signal } = controller;
        document.addEventListener('pointermove', ({ clientX, clientY })=>{
            effect.animate({
                left: [
                    `${clientX}px`
                ],
                top: [
                    `${clientY}px`
                ]
            }, {
                duration: 0,
                fill: 'forwards'
            });
        }, {
            signal
        });
        const release = ()=>{
            effect.animate({
                height: [
                    `${SIZE}px`,
                    `${SIZE * 2}px`
                ],
                width: [
                    `${SIZE}px`,
                    `${SIZE * 2}px`
                ],
                opacity: [
                    '20%',
                    '0'
                ],
                borderWidth: [
                    `${BORDER}px`,
                    '0'
                ]
            }, {
                duration: 400,
                fill: 'forwards'
            });
            controller.abort();
        };
        document.addEventListener('pointerup', release, {
            signal
        });
        document.addEventListener('pointercancel', release, {
            signal
        });
        const { left: fromX, top: fromY } = effect.getBoundingClientRect();
        const { clientX: toX, clientY: toY } = event;
        effect.animate({
            left: [
                `${fromX}px`,
                `${toX}px`,
                `${toX}px`
            ],
            top: [
                `${fromY}px`,
                `${toY}px`,
                `${toY}px`
            ],
            height: [
                '0',
                `${SIZE_ACTIVE}px`,
                `${SIZE}px`
            ],
            width: [
                '0',
                `${SIZE_ACTIVE}px`,
                `${SIZE}px`
            ],
            opacity: [
                '0',
                '20%',
                '20%'
            ],
            borderWidth: [
                '0',
                `${BORDER_ACTIVE}px`,
                `${BORDER}px`
            ],
            offset: [
                0,
                0.8
            ]
        }, {
            duration: 240,
            fill: 'forwards'
        });
    });
}

//# sourceMappingURL=repo.cb69b672.js.map
